import React from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";

import ErrorDisplayContainer from "../grundelemente/ErrorDisplayContainer";
import KompressorImageContainer from "../grundelemente/KompressorImageContainer";
import { compressorOnMotorImage, compressorOnLoadImage,
	compressorFuImageName } from "../model/Kompressor";

import "./UebersichtKompressor.css";

const UebersichtKompressor = props => (
	<div className="UebersichtKompressor">
		<KompressorImageContainer compressor={props.compressor} />
		<div className="MotorLast">
			{compressorOnMotorImage(props.compressor)}
			{compressorOnLoadImage(props.compressor)}
		</div>
		<div className="FU_Overlay">
			<Image src={compressorFuImageName(props.compressor)} />
		</div>
		<ErrorDisplayContainer component={props.compressor.cindex} />
	</div>
);

UebersichtKompressor.propTypes = {
	compressor: PropTypes.object.isRequired
};

export default UebersichtKompressor;
